//third party imports
import { ChangeDetectionStrategy, Component } from '@angular/core';

//local imports
import { UserLoggedOutMessage } from '@core/messages';
import { Messenger } from '@shared/data/messaging/messenger';

@Component({
    selector: 'login-failed',
    templateUrl: './login-failed.component.html',
    styleUrl: './login-failed.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginFailedComponent {
    constructor(private messenger: Messenger) { }

    public triggerForcedRelogin(): void {
        this.messenger.send(new UserLoggedOutMessage(true));
    }
}